const transliterations: Record<string, string> = {
  ı: "i",
  İ: "i",
  ø: "o",
  Ø: "o",
  đ: "d",
  Đ: "d",
  ł: "l",
  Ł: "l",
  ß: "ss",
  æ: "ae",
  Æ: "ae",
  œ: "oe",
  Œ: "oe",
  ð: "d",
  Ð: "d",
  þ: "th",
  Þ: "th",
};

export const foldText = (value: string): string =>
  value
    .replace(/[ıİøØđĐłŁßæÆœŒðÐþÞ]/g, (character) => transliterations[character] ?? character)
    .normalize("NFD")
    .replace(/\p{M}/gu, "")
    .toLowerCase();

export const slugify = (value: string): string =>
  foldText(value)
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+/, "")
    .replace(/-+$/, "");
